export default {
    dataset: (datasetId?: number) => ['datasets', datasetId],
    datasetColumnComponentTypes: (datasetId?: number) => [
        'datasets',
        datasetId,
        'column_component_types',
    ],
    datasetLabelColumns: (datasetId?: number) => [
        'datasets',
        datasetId,
        'label_columns',
    ],
    datasetContent: (datasetId?: number) => ['datasetContent', datasetId],
    datasetFormulas: (datasetId?: number) => ['dataset', datasetId, 'formulas'],
};
